import type { Board } from "../board";
import type { PhysicalThingWithHp } from "../physicalThingWithHp";
import { Player } from "../player";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { BaseGas } from "./baseGas";

// Yellowish gas released by slugs. Harms the player but not mobs — the
// creatures that produce it are immune.
export class BileGas extends BaseGas {
	static key = "BileGas";

	/** Add bile gas at `xy`, merging into the pressure of any gas already there. */
	static addOrPressurize(board: Board, xy: XY, amount: number): void {
		// Skip gas already dismissed this turn — pressurizing it would be lost on removal.
		const existing = board.getThingsAt(xy).find((t): t is BileGas => t instanceof BileGas && t.active);
		if (existing !== undefined) {
			existing.setCompression(existing.getCompression() + amount);
		} else {
			board.addThing(new BileGas(xy, amount));
		}
	}

	protected gasClass(): new (xy: XY, compression?: number) => BaseGas {
		return BileGas;
	}

	protected shouldDamage(thing: PhysicalThingWithHp): boolean {
		return thing instanceof Player;
	}

	static deserialize(data: any): BileGas {
		const g = new BileGas(deserializeXY(data.xy), data.compression);
		g.visualId = data.visualId;
		return g;
	}
}
